import Cookies from 'js-cookie';
import mapResultCount from './mapResultCount';

const getUser = () => {
  if (!window || !window.analytics) {
    return null;
  }
  return window.analytics.user || null;
};

export const getUserData = (eventData = {}) => {
  const data = eventData;
  const user = getUser();
  const userTraits = user ? user().traits() : {};
  const id = localStorage.getItem('member_id');

  if (id) {
    data.userMembershipID = id;
    data._ga = Cookies.get('_ga') || '';
  }
  data.visitID = Cookies.get('visit_id') || '';
  data.visitorID = Cookies.get('visitor_id') || '';

  return {data, userTraits};
};

const eventTrack = ({pageName, eventName, eventData}) => {
  if (!window || !window.analytics) {
    return;
  }

  const {track, page} = window.analytics;
  const isMobile = window?.innerWidth < 768;
  const {data, userTraits} = getUserData(eventData);
  const context = {traits: userTraits || {}};
  const props = {
    ...data,
    platform: isMobile ? 'mobile' : 'web',
    product: 'tkr store catalog',
  };

  if (pageName) {
    page(pageName, {...props, ...userTraits});
  } else {
    track(eventName, props, context);
  }
};

const trackSegmentEvent = ({
  eventName = 'Transactional Catalog PLP interaction',
  plpType = 'collection detail',
  selection,
  source,
  productCount,
  plpResultCount,
  pageName,
  name,
  type,
  value,
  ...rest
}) => {
  const trackingData = {
    eventName,
    pageName,
    eventData: {
      plpType,
      ...rest,
    },
  };
  if (selection) {
    trackingData.eventData.selection = selection;
  }
  if (source) {
    trackingData.eventData.source = source;
  }
  if (plpResultCount) {
    trackingData.eventData.plpResultCount = plpResultCount;
  } else if (productCount !== undefined) {
    trackingData.eventData.plpResultCount = mapResultCount(productCount);
  }

  eventTrack(trackingData);
};

export default trackSegmentEvent;
